import React from "react";
import { createRoot } from "react-dom/client";
import Searchbar from "../components/Header/Searchbar";

const renderSearchbar = ($) => {
	const searchBarContainer = $("#js-header-search")[0];
	if (!searchBarContainer) return;

	let props = {
		...searchBarContainer.dataset,
	};

	const root = createRoot(searchBarContainer);
	root.render(<Searchbar {...props} />);
};

export default renderSearchbar;